'use client';

import { PathInterface } from '@qlevr/shared/interfaces';
import { useLocalisation } from '@qlevr/shared/providers';
import { startTransition } from 'react';

import { useEffect } from 'react';

export interface LocalisationProps {
  localisation: PathInterface[] | null;
}

export function Localisation(props: LocalisationProps) {
  const { setLocalisation } = useLocalisation();

  useEffect(() => {
    const updateLocalisation = async () => {
      startTransition(() => {
        return setLocalisation(props.localisation ?? []);
      });
    };

    updateLocalisation();
  }, [props.localisation, setLocalisation]);

  return null;
}

export default Localisation;
